// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1TopParagraph = ({fuelType, state }) => (
    <div>
        {fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
        &&
            <p>
                <strong>
                    Status: N/A.
                </strong>&nbsp;

                Your computed average expenditures for&nbsp;{fuelType.descriptionHeat}&nbsp;households have
                not been flagged because there is no
                modified SEDS data available for households that heat with&nbsp;{fuelType.description}&nbsp;in
                your state. This means that very few households in your
                state heat with &nbsp;{fuelType.descriptionHeat}.
            </p>
        }
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            && fuelType.totalAssistedhHNum>0)
        &&
            <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your computed average heating expenditures for&nbsp;{fuelType.description}&nbsp;households
                have been flagged because your Performance Measures Form indicates that you assisted
                households that used&nbsp;{fuelType.description}&nbsp;for heating in
                &nbsp;{state.SelectedYear}&nbsp;but did NOT collect and/or report data for any of those
                households.
                <br/><br/>
                This means that you are either not collecting data on
                &nbsp;{fuelType.description}&nbsp;or not collecting enough
                &nbsp;{fuelType.description}&nbsp;expenditure data to report on your Performance Data Form.
            </p>
        }
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            && fuelType.totalAssistedhHNum===0)
        &&
            <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your Performance Measures Form indicates that you did not assist
                households that used&nbsp;{fuelType.description}&nbsp;for heating in
                &nbsp;{state.SelectedYear}.
            </p>
        }
    
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            && fuelType.totalAssistedhHNum===null)
        &&
            <p>
                <strong>
                    Status: N/A.
                </strong>&nbsp;
                Your state did not file a complete  Performance Measures report for 
                households that used&nbsp;{fuelType.description}&nbsp;for heating in
                &nbsp;{state.SelectedYear}, so we are not able to check the validity of your data.
            </p>
        }

        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues)
          &&  <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your computed average expenditures for {fuelType.description} households is
                &nbsp;{fuelType.percentOfSedsString}&nbsp;of the
                estimated average for your state based on the SEDS. Since the value reflected in
                your data is between 50% and 150% of the SEDS estimate, it is unlikely that you
                have a major data reliability issue with regards to main heating expenditures
                for {fuelType.description} households.
            </p>
        }

        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin)
          &&  <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your computed average heating expenditures for &nbsp;{fuelType.descriptionHeat}&nbsp; households have been
                flagged because your data is &nbsp;{fuelType.percentOfSedsString}&nbsp;
                of the SEDS average for &nbsp;{fuelType.descriptionHeat}&nbsp; households in your state.
                <br/><br/>
                This means that your computed average heating expenditure for {fuelType.descriptionHeat}  households
                is showing that your low-income households are spending
                &nbsp;{fuelType.percentSpendingLessString}&nbsp;less on fuel for
                heating their home than we would expect.
            </p>
        }
        {(fuelType.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax)
          &&  <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your computed average heating expenditures for &nbsp;{fuelType.descriptionHeat}&nbsp; households have been
                flagged because your data is &nbsp;{fuelType.percentOfSedsString}&nbsp;
                of the SEDS average for &nbsp;{fuelType.descriptionHeat}&nbsp; households in your state.
                <br/><br/>
                This means that your computed average heating expenditure for {fuelType.descriptionHeat}  households
                is showing that your low-income households are spending
                &nbsp;{fuelType.percentSpendingMoreString}&nbsp;more on fuel for
                heating their home than we would expect.
            </p>
        }

    </div>
);

export default Assessment1TopParagraph;
